import { type LoginRequest } from "../types/api.js";
import { withCSRF } from "./_csrf.js";

export async function login(req: LoginRequest): Promise<void> {
  const res = await fetch("/api/login", {
    method: "POST",
    credentials: "include",
    headers: withCSRF({ "Content-Type": "application/json" }),
    body: JSON.stringify(req),
  });
  if (!res.ok) throw new Error(`login: ${res.status}`);
  // Server returns 204 No Content — do NOT call res.json() (empty body → SyntaxError).
}

export async function logout(): Promise<void> {
  const res = await fetch("/api/logout", {
    method: "POST",
    credentials: "include",
    headers: withCSRF(),
  });
  if (!res.ok) throw new Error(`logout: ${res.status}`);
}
